var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletisEmpty3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 558,
    viewBox: "0 0 603 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet is Empty"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.985 535.521C405.985 539.478 355.067 542.687 292.255 542.687C229.444 542.687 178.522 539.478 178.522 535.521C178.522 531.567 229.444 528.358 292.255 528.358C355.067 528.358 405.985 531.567 405.985 535.521Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M277.888 75.2238C215.845 80.4758 193.043 132.991 211.723 163.602C224.905 185.2 247.241 214.389 288.877 207.387C330.511 200.384 334.019 161.852 312.092 156.611C290.165 151.372 212.049 175.816 220.878 232.286C227.25 273.031 282.488 284.776 282.488 284.776",
    stroke: "#D0D5DD",
    strokeWidth: 2,
    strokeDasharray: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.748 42.9851C313.748 42.9851 322.638 19.7616 323.575 10.7275C324.068 6.00684 316.245 -7.13643 307.09 5.0211C297.934 17.1786 302.111 32.0853 313.748 42.9851Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.201 17.6932C271.786 14.1712 267.071 16.9173 265.063 22.3984C263.052 27.8814 265.858 38.3179 281.566 40.6969C297.277 43.076 312.85 42.9847 312.85 42.9847C312.85 42.9847 292.616 21.2153 282.201 17.6932Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.984 47.5868C312.22 46.616 312.533 45.6856 312.881 44.7762C310.959 45.0799 309.002 45.5065 307.033 46.0841C304.897 46.709 302.904 47.5288 301.029 48.468C300.215 50.0058 299.556 51.6489 299.127 53.4132C296.489 64.2743 302.719 75.2214 313.187 78.8061C314.321 78.5814 315.46 78.3216 316.601 77.988C319.789 77.0541 322.73 75.8183 325.388 74.3858C315.165 69.9006 309.281 58.7077 311.984 47.5868Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.038 53.2508C297.288 52.1778 297.628 51.1518 298.004 50.1493C288.947 55.9513 283.876 64.9559 284.712 70.207C278.925 72.6943 275.239 74.7897 275.239 74.7897C275.239 74.7897 279.605 74.4573 285.968 73.2344C289.376 78.2145 298.823 81.549 309.268 80.3532C299.806 75.4598 294.465 64.3237 297.038 53.2508Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.749 57.4397C324.51 56.9005 323.123 54.6431 323.662 52.3824C324.199 50.1371 326.461 48.7458 328.698 49.285C330.947 49.8278 332.321 52.0937 331.785 54.3407C331.245 56.5997 328.999 57.9807 326.749 57.4397ZM316.291 45.0048C315.845 46.041 315.466 47.1342 315.195 48.2664C312.821 58.1928 318.305 68.1778 327.606 71.6412C335.367 66.7918 339.724 59.9253 337.956 53.9633C335.991 47.2757 326.953 43.8221 316.291 45.0048Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.247 463.881H408.282C413.937 463.881 418.523 459.284 418.523 453.615V304.02C418.523 298.338 413.926 293.732 408.259 293.732H179.835C177.131 293.732 174.94 295.928 174.94 298.638V453.549C174.94 459.255 179.553 463.881 185.247 463.881Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.11 462.089H212.175C212.382 462.089 212.552 461.92 212.552 461.711V272.617C212.552 272.408 212.382 272.239 212.175 272.239H185.11C179.492 272.239 174.94 276.777 174.94 282.378V451.95C174.94 457.55 179.492 462.089 185.11 462.089Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.442 399.403H432.475C432.681 399.403 432.851 399.232 432.851 399.02V356.801C432.851 356.59 432.681 356.418 432.475 356.418H362.442C356.817 356.418 352.254 361.036 352.254 366.73V389.092C352.254 394.787 356.817 399.403 362.442 399.403Z",
    fill: "#1570EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.855 272.239H185.355V272.264C179.584 272.403 174.94 277.137 174.94 282.986C174.94 288.834 179.584 293.569 185.355 293.708V293.731H389.486C389.695 293.731 389.866 293.561 389.866 293.35V284.339C389.866 277.656 384.487 272.239 377.855 272.239Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.283 377.91C386.283 382.856 382.275 386.865 377.328 386.865C372.382 386.865 368.373 382.856 368.373 377.91C368.373 372.964 372.382 368.955 377.328 368.955C382.275 368.955 386.283 372.964 386.283 377.91Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 25",
    d: "M19.1195 333.134V338.508",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 27",
    d: "M8.37305 338.507L11.9551 342.09",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    d: "M3 349.254H8.37313",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 31",
    d: "M8.37305 360L11.9551 356.418",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 33",
    d: "M19.1195 365.373V360",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 35",
    d: "M29.8658 360L26.2837 356.418",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 37",
    d: "M35.2387 349.254H29.8656",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 39",
    d: "M29.8658 338.507L26.2837 342.09",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 41",
    d: "M294.94 112.836V116.418",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 43",
    d: "M285.985 121.791H289.567",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 45",
    d: "M294.94 132.537V128.955",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 47",
    d: "M305.687 123.582H302.105",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 49",
    d: "M97.9252 254.328V259.701",
    stroke: "#D0D5DD",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 51",
    d: "M81.806 270.448H87.1792",
    stroke: "#D0D5DD",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 53",
    d: "M96.1344 284.776V279.403",
    stroke: "#D0D5DD",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 55",
    d: "M112.254 270.448H106.88",
    stroke: "#D0D5DD",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 57",
    d: "M463.299 442.388C467.255 442.388 470.463 445.596 470.463 449.553C470.463 453.509 467.255 456.717 463.299 456.717C459.342 456.717 456.134 453.509 456.134 449.553",
    stroke: "#F04438",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 59",
    d: "M497.209 540.072C498.123 546.468 493.702 552.397 487.337 553.313C480.976 554.23 475.076 549.788 474.164 543.392C473.252 536.995 477.671 531.066 484.036 530.15",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.328 374.328C501.67 372.954 508.325 367.577 509.866 361.791C511.262 366.906 517.118 372.954 522.403 373.414C516.455 375.548 510.768 381.887 509.866 386.866C509.251 381.791 501.387 375.067 497.328 374.328Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7759 439.7C49.9478 439.015 53.2748 436.325 54.0454 433.433C54.7434 435.989 57.67 439.015 60.3132 439.244C57.3387 440.311 54.4954 443.48 54.0454 445.97C53.7372 443.433 49.8061 440.07 47.7759 439.7Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1789 202.388C87.1789 205.357 84.7727 207.762 81.8058 207.762C78.8371 207.762 76.4326 205.357 76.4326 202.388C76.4326 199.42 78.8371 197.015 81.8058 197.015C84.7727 197.015 87.1789 199.42 87.1789 202.388Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603 191.641C603 195.599 599.794 198.806 595.837 198.806C591.879 198.806 588.672 195.599 588.672 191.641C588.672 187.684 591.879 184.478 595.837 184.478C599.794 184.478 603 187.684 603 191.641Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 73",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.06 164.776C191.06 167.745 188.654 170.149 185.687 170.149C182.718 170.149 180.313 167.745 180.313 164.776C180.313 161.807 182.718 159.403 185.687 159.403C188.654 159.403 191.06 161.807 191.06 164.776Z",
    stroke: "#53B1FD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.636 504.604C103.939 506.011 99.8025 504.154 98.396 500.457C96.9876 496.76 98.8461 492.623 102.543 491.217C106.24 489.809 110.377 491.667 111.783 495.364C113.19 499.061 111.333 503.198 107.636 504.604Z",
    stroke: "#D0D5DD",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletisEmpty3X);
export default __webpack_public_path__ + "static/media/WalletisEmpty@3x.2314102ac8c35b0eac8353f47ef87814.svg";
export { ForwardRef as ReactComponent };